import type {MediaTypePreviewIconType} from './components/media-type-preview-icon/media-type-preview-icon.types';

export interface MediaTypeToggleOption<TOptionId extends string = string> {
  id: TOptionId;
  text: string;
  previewIconType: MediaTypePreviewIconType;
}

export interface SocialMediaMediaTypeToggleProps<TOptionId extends string = string> {
  options: MediaTypeToggleOption<TOptionId>[];
  selectedId: TOptionId;
  onSelect: (selectedId: TOptionId) => void;
  isDisabled?: boolean;
  disabledTooltipText?: string;
  containerClassName?: string;
}

export const MEDIA_TYPE_TOGGLE_KEYBOARD_KEYS = {
  ARROW_DOWN: 'ArrowDown',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  ARROW_UP: 'ArrowUp',
  SPACE: ' ',
} as const;

export enum MediaTypeToggleNavigationDirection {
  NEXT = 'next',
  PREVIOUS = 'previous',
}

export const ROVING_TAB_INDEX_FOCUSABLE = 0;
export const ROVING_TAB_INDEX_UNFOCUSABLE = -1;
